// extracted by mini-css-extract-plugin
export default {"page":"page__QQ8acx","backLink":"backLink__fxsJdM","card":"card__LRp3jt","title":"title__eLem_8","flag":"flag__lCqUBL","loading":"loading__tNcbsZ","body":"body__eExILl"};